import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { CompensationReadApiClient, People } from '~/services/Http';

export const GET_COMPENSATIONS_SWR_KEY =
  'CompensationReadApiClient.getCompensationsSummary';

export function useGetCompensationsSummary(args: {
  employeeId: string;
}): UseSWROutput<People.CompensationsSummaryDto> {
  return useSWR(
    [GET_COMPENSATIONS_SWR_KEY, args.employeeId],
    ([_, employeeId]) =>
      CompensationReadApiClient.getCompensationsSummary(employeeId).then(
        (r) => r.data,
      ),
  );
}
